import _ from "@lodash";
import { withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import CatchErro from 'app/Core/Components/CatchErro/CatchErro';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as Helpers from 'app/Core/Helpers';
import withReducer from 'app/store/withReducer';
import classNames from 'classnames';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import DialogFactory from '../Dialogs/DialogFactory';
import * as Actions from '../Store/Actions/MinhasTarefasActions';
import reducer from '../Store/Reducers';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    footer: {
        display: 'flex'
    },
    btnNovoFluxo: {
        zIndex: 9999
    },
});

const parametros = {
    nome: "Novo fluxo",
    procedure: "spvwflowminhastarefas",
    tabs: [],
    condicoes: {
        AND: []
    }
}

class NovoFluxoApp extends XAPPComponent {

    state = {
        open: null,
        inicio: Helpers.GetDataFirstTime("usa"),
        termino: Helpers.GetDataLastTime("usa"),
        idtarefaprocesso: null,
        idpessoaformulario: null,
        conditions: null
    }

    handleFiltro = (_AValue) => {
        var obj = { ...this.state };
        Object.keys(_AValue).forEach(key => {
            if (!_.isUndefined(_AValue[key]) && !_.isEqual(obj[key], _AValue[key])) {
                obj[key] = _AValue[key];
            }
        });
        obj.conditions = null;
        this.setState(obj);
    }

    getFiltro = () => {
        return this.state;
    }

    openDialog = (_AValue) => {
        this.setState({ "open": _AValue });
        this.props.clearMinhaTarefa();
    }

    setConditions = (_AValue) => {
        this.setState({ conditions: _AValue });
    }

    getTabValue = (_AValue) => {
        /**NAO REMOVER */
    }

    render() {
        const { classes, idpessoa, callback, data, label, minhatarefa, xappRouteParams, tipo, type, className, variant, color, icon, iconProps, tooltip, idfluxo } = this.props;

        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    {minhatarefa !== null &&
                        <DialogFactory
                            xappRouteParams={xappRouteParams}
                            getFiltro={this.getFiltro}
                            listFilter={callback !== undefined ? callback : () => { }}
                            parametros={parametros}
                            data={data}
                        />
                    }
                    <XAPPButton
                        type={type}
                        className={classNames(classes.btnNovoFluxo, className)}
                        variant={variant}
                        color={color}
                        iconProps={iconProps}
                        icon={icon}
                        tooltip={tooltip}
                        xappRouteParams={xappRouteParams}
                        label={label}
                        onClick={() => this.props.getFluxo("SELECIONAR", xappRouteParams, tipo, idpessoa, data, idfluxo)}
                    />
                </CatchErro>
            </React.Fragment>

        );
    }
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        getFluxo: Actions.getFluxo,
        clearFluxo: Actions.clearFluxo
    }, dispatch);
}

function mapStateToProps({ MinhasTarefas }) {
    return {
        MinhasTarefas: MinhasTarefas.MinhasTarefasReducer,
        minhatarefa: MinhasTarefas.MinhasTarefasReducer.minhatarefa,
    }
}
export default withReducer('MinhasTarefas', reducer)(withStyles(styles, { withTheme: true })((withRouter(connect(mapStateToProps, mapDispatchToProps)(NovoFluxoApp)))));